import Datum from '@/interfaces/Datum';
import Palette from '@/interfaces/Palette';

export function sortForDisplay(palette: Palette) {
  const getInd = (d: Datum) => d.sortKey ? d.sortKey : d.id;
  return palette.sort((a, b) => getInd(a.data) - getInd(b.data));
}
